<div class="order box-content">
  <ng-container *ngFor="let summary of summaryList">
    <div class="flex-item" (click)="gotoOrderPage(summary.status)">
      <div class="label-contain">
        <div class="label-text">
          {{ summary.text }}
        </div>
        <div [ngClass]="{ 'negative-number': summary?.showNegativeCls }">{{ summary.totalCost }}</div>
        <div class="num-contain">
          <span class="num">{{ summary.count }}</span>
        </div>
      </div>
      <img src="{{ 'assets/img/right.png' | xviSourcePath }}" />
    </div>
    <div class="last-days" *ngIf="summary.status === 'open'">{{ last7Days }}</div>
  </ng-container>
</div>
